<mat-card fxLayout="column">
    <mat-card-content>
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
            <div fxFlex="20%;" fxFlex.xs="80%">
                <button type="button" [routerLink]="[quoteListUrl]" mat-raised-button color="primary">View Quote Records</button>
            </div>
        </div>
    </mat-card-content>
</mat-card>